import type { FaireProductEntity } from "../../entity_types/product";

export const p_429baacbvp: FaireProductEntity = {
  token: "p_429baacbvp",
  type: "product",
  name: "3P4 x Peanuts® Halloween - Snoopy Witch Air Freshener",
  brandToken: "b_ajtucnxx1w",
  brandName: "Three Potato Four",
  imageUrl:
    "https://cdn.faire.com/fastly/9c40a4b27f44f26c2cfad51ce30c98f25cfa13a6b8183dd55223a62cb052cd72.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8491cde561dc337d426bda42995a0b52126e7ac810a9fb60c2200f05ed915ca.jpeg",
    "https://cdn.faire.com/fastly/d49786a9e9bac7c52ddc05ebfff49f94dff0137b7d0d03b6a60c66ddc323d462.jpeg",
    "https://cdn.faire.com/fastly/9815223a86b415e318274751371488d92a8d7cf8b7d4579ce6ae877abf769c71.jpeg",
  ],
  priceDollars: 4.95,
  description:
    'Inspired by the unforgettable look of 1970s dime store Halloween novelties, our Snoopy Halloween Collection celebrates the season through vintage packaging, classic Peanuts characters, and all the nostalgic charm of Halloween\n\n• Officially Licensed Product of Peanuts©\n• Hanging Air Freshener\n• Approximately 3" with Hanging Elastic Band\n• Produced and packaged in the USA\n• Hinoki Scent',
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:35.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
